module.exports = __webpack_public_path__ + "static/media/popup.64d10ea7.png";